import React from "react";
import {Route} from "react-router-dom";

import RequireAuthentication from "hoc/authentication/requireAuthentication";
import RetailerUnloader from "hoc/retailer/retailerUnloader";

import Workspace from "views/personalShopper";

import {Authorizations, hasAuthorization} from "utils/authorizations";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";
import {sessionStore} from "utils/sessionStore";

let routes = [];
const authorizations = sessionStore.get("authorizations") ?? [];

// The WhatsApp personal shopper is organization-level: the authorization cannot be given to
// a member attached to a retailer, so the authorization alone gates the screens.
if (hasAuthorization(authorizations, Authorizations.PERSONALSHOPPER_MANAGEMENT)) {
    // One route for the list alone and for the list with a conversation open: the same
    // workspace, so the list keeps its tab, search and page while conversations are opened.
    routes.push([
        <Route
            path={[MarketplaceRoutes.PERSONAL_SHOPPER, `${MarketplaceRoutes.PERSONAL_SHOPPER}/conversations/:id`]}
            component={RequireAuthentication(RetailerUnloader(Workspace))}
            exact
            key="personalShopperWorkspace"
        />,
    ]);
}

export default routes;
